import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Styles from 'pages/provisioning/nsg-automation-rules/components/sticky-header/style';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const StickyHeader = (props) => {
    const { title, iconPath, showCartBtn, cartBtn, back, handleBackBtn, showInfoIcon, infoIcon } = props;
    return (
        <Box sx={Styles?.mainWrapper} data-testid="sticky-header-wrapper">
            <Box sx={Styles?.wrapper} data-testid="sticky-header" className="contentContainer">
                <Box sx={Styles?.subWrapper}>
                    <Box style={Styles?.ImgSpan}>
                        {back && (
                            <IconButton onClick={handleBackBtn} sx={Styles?.backBtn} data-testid="back-icon">
                                <ArrowBackIosNewIcon sx={Styles?.backIcon} />
                            </IconButton>
                        )}
                        <img src={iconPath} alt="" style={Styles?.img} />
                    </Box>
                    <Box sx={Styles?.title}>{title}</Box>
                    {showInfoIcon && <Box sx={Styles?.infoIconStyle}>{infoIcon}</Box>}
                </Box>
                {showCartBtn && <Box sx={Styles?.buttonWrapper}>{cartBtn}</Box>}
            </Box>
        </Box>
    );
};

StickyHeader.propTypes = {
    title: PropTypes.string,
    iconPath: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    showCartBtn: PropTypes.any,
    cartBtn: PropTypes.any,
    handleBackBtn: PropTypes.func.isRequired,
    back: PropTypes.bool,
    showInfoIcon: PropTypes.bool,
    infoIcon: PropTypes.any,
};

StickyHeader.defaultProps = {
    title: '',
    iconPath: '',
    showCartBtn: false,
    cartBtn: null,
    back: false,
    showInfoIcon: false,
    infoIcon: null,
};

export default React.memo(StickyHeader);
